import React from 'react';
import { product as productLabels } from '../../mockdata';
import IndexWrapper from '../IndexWrapper/IndexWrapper';

export default function NotFoundPage({ locale }: { locale: string }) {
  return (
    <IndexWrapper
      locale={locale}
      labels={productLabels}
      name={productLabels.error}
      backLink={{
        href: '/',
        children: productLabels.back_to_list,
      }}
      disableNotePadding
    />
  );
}
